import { resourcesRoot } from "from-start/scene/resources";
import * as R from "ramda";
import { Background } from "./background";
import { Button } from "./button";
import { Title } from "./title";
// export const soundFileName = "사운드.mp3";
export const soundFileName = "사운드.m4a";
export const soundFilePath = toPath(soundFileName);
export function toPath(fileName) {
    return `${resourcesRoot}/7-king/${fileName}`;
}
export const resourcePaths = [
    ...R.compose(R.map((n) => `sheet${n}.png`), R.range)(0, 7),
    ...R.compose(R.map((n) => `sheet${n}.json`), R.range)(0, 7),
].map((name) => toPath(name));
export { Background, Title, Button };
//# sourceMappingURL=resources.js.map